import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { User } from '../../_models';
import { UserService, AuthenticationService, NotificationService, EnvService } from '../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ templateUrl: 'clients.component.html' })
export class ClientsComponent implements OnInit {
  form: FormGroup;
  newManagerForm: FormGroup;
  editManagerForm: FormGroup;
  currentUser: User;
  loading = false;
  users: User[];
  role = null;
  username = "";
  itemsPerPage = 20;
  pagingList = [20, 40, 60, 80, 100];
  roleList = {};
  totalItems = 0;
  maxSize = 0;
  numPages = 0;
  selectedManager: User;
  processing = false;
  page: number;
  currentPage = 1;
  emptyResult = false;

  showError = false;
  showPw = false;
  rsPw = '';

  constructor(private fb: FormBuilder,
    private userService: UserService,
    private envService: EnvService,
    private authSvc: AuthenticationService,
    private modalService: NgbModal,
    private notification: NotificationService) {
    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit() {
    this.buildForm();
    this.loadRoles();
    this.search(this.form.value);
  }

  buildForm(): void {
    this.form = this.fb.group({
      role: [2],
      username: ['']
    });

    this.editManagerForm = this.fb.group({
      id: [''],
      role: [''],
      username: ['']
    });
  }

  openModal(targetModal, user = null) {
    this.processing = false;
    this.showPw = false;
    this.rsPw = '';
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder'
    });

    if (user != null) {
      this.editManagerForm.patchValue({
        username: user.username,
        role: user.role,
        id: user.id
      });
    } else {
      this.newManagerForm = this.fb.group({
        role: [2, Validators.required],
        username: ['', Validators.required],
        password: ['', [Validators.required, Validators.minLength(5)]]
      });
    }
  }

  onSubmit() {
    this.processing = true;
    var updateParam = this.editManagerForm.getRawValue();
    if (confirm("Are you sure to update this manager?")) {
      this.userService.updateManager(updateParam).subscribe(data => {
        if (data !== null) {
          this.notification.showSuccess("User updated successfully!", "Update User");
          this.modalService.dismissAll();
          this.loadPage();
        } else {
          this.notification.showError("Failed to update user, please try again later.", "Fail update");
        }
      })
    }
    this.processing = false;
  }

  onNewSubmit() {
    this.processing = true;
    var newData = this.newManagerForm.getRawValue();
    if (this.newManagerForm.valid) {
      if (confirm("Are you sure to update this manager?")) {
        this.userService.addManager(newData).subscribe(data => {
          if (data.id) {
            this.notification.showSuccess("Added user successfully!", "New User");
            this.modalService.dismissAll();
            this.loadPage();
          } else {
            this.notification.showError(data.msg, "Fail Add");
          }
        })
      }
      this.processing = false;
      this.showError = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add failed");
      this.processing = false;
    }

  }

  get f() { return this.newManagerForm.controls; }

  deleteManager(manager) {
    if (confirm("Are you sure to delete this manager?")) {
      this.userService.deleteManager(manager.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("User deleted successfully!", "Deleted User");
          this.loadPage();
        } else {
          this.notification.showError("Error deleting users, please try again later.", "Error");
        }
      })
    }
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  search(filters: any): void {
    // var temp = [];
    // this.searchTerm = [];
    // Object.keys(filters).forEach(key => filters[key] === '' ? delete filters[key] : temp.push(key));
    // temp.forEach(t => {
    //   var predicateObject = {};
    //   predicateObject[t] = filters[t];
    //   this.searchTerm.push(predicateObject);
    // });
    var checkRole = filters.role == "" ? null : filters.role;
    var checkName = filters.username;
    if (checkRole && isNaN(parseInt(checkRole))) {
      if (filters.role == "admin") {
        checkRole = 1;
      } else {
        checkRole = 2;
      }
    }
    this.role = checkRole;
    this.username = checkName;
    this.totalItems = 0;
    this.loadPage(1);
  }

  resetPw() {
    if (confirm("Are you sure to reset password?")) {
      this.userService.resetManagerPassword(this.editManagerForm.getRawValue().id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Password reseted successfully!", "Reset Password");
          this.showError = false;
          this.showPw = true;
          this.rsPw = data.data;
        } else {
          this.notification.showError(data.msg, "Update failed");
        }
      })
    }
  }

  private loadRoles() {
    this.envService.getRoles().pipe(first()).subscribe(data => {
      this.roleList = data.data;
    })
  }

  private loadPage(page = null) {
    this.loading = true;
    this.emptyResult = false;
    this.users = [];
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      role: this.role || null,
      username: this.username || ""
    }
    // get page of items from api
    this.userService.getAll(params).pipe(first()).subscribe(data => {
      if (data !== null && data.status == 1 && data.data.list != null) {
        this.loading = false;
        this.totalItems = data.data.total;
        this.currentPage = data.data.page + 1;
        this.maxSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
        this.users = data.data.list;
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no users at the moment.", "Empty Result");
      }
    });
  }
}
